import useBaseConfiguration from '../base/baseConfiguration';
import useBaseSettings from '../base/baseSettings'
import useBaseMapConfiguration from '../base/baseMapConfiguration'
import useBaseProducts from '../base/baseProducts'
import useBaseUserConfiguration from '../base/baseUserConfiguration'
import useBaseAdConfiguration from '../base/baseAdConfiguration'

import useParameters from '../base/baseUrlParameters';
import useAppConfiguration from './prod/appConfiguration';
import useAppMapConfiguration from './shared/appMapConfiguration'
import useAppSettings from './shared/appSettings';
import useAppProducts from './shared/appProducts';
import useAppUserConfiguration from './prod/appUserConfiguration';
import useAppAdConfiguration from './shared/appAdConfiguration'

import useJweatherGlobalsTransformer from './shared/appJweatherGlobalsTransformer'
import useBaseJweatherConfig from '../base/baseJweatherConfig'
import useAppJweatherConfig from './shared/appJweatherConfig'

import { deepMerge } from '@/helpers/deepMerge'

window.$App = window.$App || {}
window.$App.globals =  window.$App?.globals || {}
window.jweather = window.jweather || {}

const parameters = useParameters();

const baseConfiguration = useBaseConfiguration(parameters);
const appConfiguration = useAppConfiguration(parameters)
const siteConfiguration = window.$App.globals.configuration || {}

const baseUserConfiguration = useBaseUserConfiguration(parameters);
const appUserConfiguration = useAppUserConfiguration(parameters)
const siteUserConfiguration = window.$App.globals.user || {}

const baseMapConfiguration = useBaseMapConfiguration(parameters)
const appMapConfiguration = useAppMapConfiguration(parameters)
const siteMapConfiguration = window.$App.globals.map || {}

const baseSettings = useBaseSettings(parameters);
const appSettings = useAppSettings(parameters)
const siteSettings = window.$App.globals.settings || {}

const baseProducts = useBaseProducts(parameters);
const appProducts = useAppProducts(parameters)
const siteProducts = window.$App.globals.products || {}

window.$App.globals.configuration = deepMerge({}, baseConfiguration, appConfiguration, siteConfiguration);
window.$App.globals.map = deepMerge({}, baseMapConfiguration, appMapConfiguration, siteMapConfiguration);
window.$App.globals.settings = deepMerge({}, baseSettings, appSettings, siteSettings);
window.$App.globals.products = deepMerge({}, baseProducts, appProducts, siteProducts);
window.$App.globals.user = deepMerge({}, baseUserConfiguration, appUserConfiguration, siteUserConfiguration);

// Ad configuration needs to be done after the merging of the configuration globals to maker sure the brand is set
const baseAdConfiguration = useBaseAdConfiguration(window.$App.globals.configuration)
const appAdConfiguration = useAppAdConfiguration(parameters);
const siteAdConfiguration = window.$App.globals.ads || {}
window.$App.globals.ads = deepMerge({}, baseAdConfiguration, appAdConfiguration, siteAdConfiguration);

useJweatherGlobalsTransformer(parameters);
useBaseJweatherConfig(parameters)
useAppJweatherConfig(parameters)